//#region Imports
import * as React from "react";
import type { AnalyticsEventsTypesMapT } from "@anydo/analytics";
import { useAnalytics } from "./useAnalytics";
//#endregion

//#region Types
type PropsT<Event extends keyof AnalyticsEventsTypesMapT> = AnalyticsEventsTypesMapT[Event] & {
  event: Event;
};
//#endregion

export function TrackOnMount<Event extends keyof AnalyticsEventsTypesMapT>({ event, ...rest }: PropsT<Event>) {
  const { track } = useAnalytics();

  React.useEffect(() => {
    // @ts-expect-error Limitation of types map
    track<Event>(event, rest);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
